import 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';

interface SkipModalProps {
  open: boolean;
  onClose?: () => void;
  onSkip?: () => void;
}

export const SkipModal = ({ open, onClose, onSkip }: SkipModalProps) => (
  <Modal title="Do you want to skip?" width="medium" onClose={onClose} open={open}>
    <ModalBody>
      Skipping challenges solves them automatically and may take some time. You can't undo solved challenges unless you
      restart.
    </ModalBody>

    <ModalFooter>
      <Button variant="outline" tw="mr-2" onClick={onClose}>
        Cancel
      </Button>

      <Button onClick={onSkip} data-testid="confirm-skip">
        Skip
      </Button>
    </ModalFooter>
  </Modal>
);
